import { render, staticRenderFns } from "./IviewDatePicker.vue?vue&type=template&id=57b58ad7&scoped=true&"
import script from "./IviewDatePicker.vue?vue&type=script&lang=js&"
export * from "./IviewDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./IviewDatePicker.vue?vue&type=style&index=0&id=57b58ad7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b58ad7",
  null
  
)

/* custom blocks */
import block0 from "./IviewDatePicker.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports